import { h } from 'preact';
import { useState } from 'preact/hooks';
import { Modal } from '../Modal';
import { Button } from '../Button';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

function ModalShowcaseWrapper() {
  const [open, setOpen] = useState(false);
  const [lgOpen, setLgOpen] = useState(false);
  return (
    <div>
      <div style={{ display: 'flex', gap: 8 }}>
        <Button onClick={() => setOpen(true)}>Abrir Modal</Button>
        <Button variant="secondary" onClick={() => setLgOpen(true)}>Abrir Modal LG</Button>
      </div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Exemplo de Modal"
        footer={
          <>
            <Button variant="ghost" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button variant="primary" onClick={() => setOpen(false)}>Confirmar</Button>
          </>
        }
      >
        <div style={{ color: T.text }}>Conteúdo do modal. Clique no overlay ou no X para fechar.</div>
      </Modal>
      <Modal
        open={lgOpen}
        onClose={() => setLgOpen(false)}
        title="Modal Grande (size=lg)"
        size="lg"
        footer={<Button variant="primary" onClick={() => setLgOpen(false)}>Fechar</Button>}
      >
        <div style={{ color: T.text }}>Este modal usa size="lg" para conteúdo mais amplo.</div>
      </Modal>
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'Modal',
  category: '🪟 Modais & Overlay',
  description: 'Modal com título, footer, tamanhos (default, lg) e overlay clicável',
  usedIn: ['Chat', 'AgentesPage', 'AffiliatesPanel'],
  example: () => <ModalShowcaseWrapper />,
};
